import { useEffect, useState } from 'react'
import {
  useWbsItemSelectColumnOptions,
  WbsItemSelectColumnOptionType,
} from '../../../hooks/useWbsItemSelectColumnOptions'

export const useSelectColumnOptions = (projectUuid: string) => {
  const [selectColumnOptions, setSelectColumnOptions] = useState<
    WbsItemSelectColumnOptionType | undefined
  >(undefined)
  const {
    fetchedSelectColumnOptions: fetchedWbsItemSelectColumnOptions,
    selectColumnOptions: wbsItemSelectColumnOptions,
  } = useWbsItemSelectColumnOptions({
    projectUuid,
    targetColumnOptionTypes: [
      'STATUS',
      'PRIORITY',
      'DIFFICULTY',
      'TEAM',
      'MEMBER',
      'SPRINT',
      'TAG',
    ],
  })

  useEffect(() => {
    if (!fetchedWbsItemSelectColumnOptions) return
    setSelectColumnOptions(prevState => ({
      ...(prevState || {}),
      status: wbsItemSelectColumnOptions
        ? wbsItemSelectColumnOptions['status']
        : [],
      priority: wbsItemSelectColumnOptions
        ? wbsItemSelectColumnOptions['priority']
        : [],
      difficulty: wbsItemSelectColumnOptions
        ? wbsItemSelectColumnOptions['difficulty']
        : [],
      team: wbsItemSelectColumnOptions
        ? wbsItemSelectColumnOptions['team']
        : [],
      member: wbsItemSelectColumnOptions
        ? wbsItemSelectColumnOptions['member']
        : [],
      sprint: wbsItemSelectColumnOptions
        ? wbsItemSelectColumnOptions['sprint']
        : [],
      tag: wbsItemSelectColumnOptions ? wbsItemSelectColumnOptions['tag'] : [],
    }))
  }, [fetchedWbsItemSelectColumnOptions, wbsItemSelectColumnOptions])

  return {
    selectColumnOptions,
  }
}
